import axiosInstance from "../app/axios";
import { CharterDTO } from "../components/charter/list";

interface PaginatedChartersProps {
  page: number;
  take: number;
}

export const getPaginatedCharters = async ({
  page,
  take,
}: PaginatedChartersProps) => {
  const result = await axiosInstance.get(
    `charters?page=${page}&take=${take}`,
  );
  return result.data;
};

export const getSelectableCharters = async () => {
  const result = await axiosInstance.get(
    "charters/selectable",
  );
  return result.data;
};

export const createCharter = async (charter: CharterDTO) => {
  const result = await axiosInstance.post("charters", charter);
  return result.data;
};

export const updateCharter = async (id: number, charter: CharterDTO) => {
  const result = await axiosInstance.put(`charters/${id}`, charter);
  return result.data;
};

export const deleteCharter = async (id: number) => {
  const result = await axiosInstance.delete(`charters/${id}`);
  return result.data;
};